import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Heading1, Layout, Eyebrow } from "@stellar/design-system";
export var NotFound = function () {
    var navigate = useNavigate();
    var location = useLocation();
    var handleBack = function () {
        navigate({ pathname: "/", search: location.search });
    };
    return (_jsx(Layout.Inset, { children: _jsxs("div", { className: "NotFound", children: [_jsx(Eyebrow, { children: "Error 404" }), _jsx(Heading1, { children: "Sorry, that page couldn\u2019t be found." }), _jsx("p", { children: "Have you tried turning it off and on again?" }), _jsx(Button, { onClick: handleBack, children: "Back to Home" })] }) }));
};
